import { createElement } from '../../../core/dom/helpers.js';

/**
 * @param {() => void} fn
 * @param {number} ms
 * @returns {{ (): void, cancel: () => void }}
 */
function debounce(fn, ms) {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let timeout;
  function debounced() {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(), ms);
  }
  debounced.cancel = () => clearTimeout(timeout);
  return debounced;
}

/** @type {import('../../../contracts/filters.js').FilterDriver} */
export const textFilterDriver = {
  type: 'text',
  mount(container, ctx) {
    const { def, onChange } = ctx;

    const input = /** @type {HTMLInputElement} */ (createElement('input', {
      type: 'text',
      id: `filter-${def.key}`,
      name: def.key,
    }));
    if (typeof ctx.value === 'string') {
      input.value = ctx.value;
    }
    if (def.placeholder) {
      input.setAttribute('placeholder', def.placeholder);
    }

    const debouncedOnChange = debounce(() => onChange(input.value), 300);

    input.addEventListener('input', () => debouncedOnChange());
    container.appendChild(input);

    return {
      setValue(value) {
        // Imperative rewrite cancels any pending debounced onChange — the new
        // value is canonical, any in-flight user keystroke is obsolete.
        debouncedOnChange.cancel();
        input.value = typeof value === 'string' ? value : '';
      },
      getValue() {
        return input.value;
      },
      destroy() {
        debouncedOnChange.cancel();
        input.remove();
      },
    };
  },
};
